export class ReferentielModel {
  public id: number = null;
  public active: boolean = null;
  public category: string = null;
  public label: string = null;
  public order: number = null;
  public codeRef: string = null;
  public orderCode;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ReferentielModel[] = [];
    jsons.forEach(json => {
      refs.push(new ReferentielModel().fromJSON(json));
    });
    return refs;
  }
}
